/**
 * Constantes de layout compartilhadas.
 *
 * Regra de 2026-08-19 (D2/D9): existe UMA altura de barra no app. Todas as
 * barras do topo — header da conversa, linha de abas do chat, header do
 * histórico, painel de leitura de e-mail, lista de e-mail, topo da sidebar e
 * PageToolbar — usam o mesmo número. É isso que faz a borda de baixo de duas
 * barras vizinhas cair no mesmo pixel.
 */

/** Altura de qualquer barra do topo, em px. */
export const HEADER_HEIGHT = 56;

/**
 * Altura da faixa de contexto do celular (M1) — a 2ª linha do header da
 * conversa, com as pílulas CRM / Cliente / Tags em rolagem horizontal.
 * Header mobile de conversa individual = HEADER_HEIGHT + esta faixa + 1px de borda.
 * Conversa de grupo não tem a faixa: o header volta a HEADER_HEIGHT.
 */
export const MOBILE_CONTEXT_STRIP_HEIGHT = 48;
